import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

//Pages
import { SignUpPage, LoginPage } from 'modules/onboarding/pages';
import { CreateQuotePage, QuotePage, SendQuotePage } from 'modules/quote/pages';
import { EmailConfirmationPage } from 'modules/email-confirmation';
import { EmailVerificationPage } from 'modules/email-verification';
import { ProfilePage } from 'modules/profile';

//OLD Pages

import { Credit, Portfolio, CreditApp, Lease } from 'app/pages';

class AppRoutes extends Component {
    render() {
        return (
            <Switch>
                {/* public routes */}
                <PublicRoute
                    path="/login"
                    component={LoginPage}
                    appState={this.props.appState}
                />
                <PublicRoute
                    path="/signup"
                    component={SignUpPage}
                    appState={this.props.appState}
                />

                {/* private routes */}
                <PrivateRoute
                    path="/email_verification/:token"
                    component={EmailVerificationPage}
                    appState={this.props.appState}
                />
                <PrivateRoute
                    path="/profile/:nextUrl"
                    component={ProfilePage}
                    appState={this.props.appState}
                />
                <PrivateRoute
                    path="/email_confirmation"
                    component={EmailConfirmationPage}
                    appState={this.props.appState}
                />
                <PrivateRoute
                    path="/quote/send/:quoteId"
                    component={SendQuotePage}
                    appState={this.props.appState}
                />
                <PrivateRoute
                    path="/quote/:quoteId/share/:shareId"
                    component={QuotePage}
                    appState={this.props.appState}
                />
                <PrivateRoute
                    path="/quote/:quoteId"
                    component={QuotePage}
                    appState={this.props.appState}
                />
                <PrivateRoute
                    path="/quotes"
                    component={CreateQuotePage}
                    appState={this.props.appState}
                />
                <PrivateRoute
                    path="/credit/:quoteId"
                    component={Credit}
                    appState={this.props.appState}
                />
                <PrivateRoute
                    path="/credit"
                    component={Credit}
                    appState={this.props.appState}
                />

                <PrivateRoute
                    path="/portfolio/lease/:leaseId"
                    component={Lease}
                    appState={this.props.appState}
                />
                <PrivateRoute
                    path="/portfolio/credit/:creditAppId"
                    component={CreditApp}
                    appState={this.props.appState}
                />
                <PrivateRoute
                    path="/portfolio"
                    component={Portfolio}
                    appState={this.props.appState}
                />

                <PrivateRoute
                    component={CreateQuotePage}
                    appState={this.props.appState}
                />
                {/* <Route component={CreateQuotePage} />  */}
            </Switch>
        );
    }
}

export default AppRoutes;



// WEBPACK FOOTER //
// ./src/modules/router/AppRoutes.jsx